import CartBlock from "../Components/CartBlock/CartBlock";

const Cart = () => {
  return <CartBlock />;
};
export default Cart;
